module.exports = __webpack_public_path__ + "img/logo_zurich.27cd7ea0.png";